import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import { PATTERNS, USER_TYPE } from "constants/appConstant";
import { getIn, useFormik } from "formik";
import Papa from "papaparse";
import { doCreateBroadcastList } from "stores/slices/broadcastList";
import { getAllCustomField } from "stores/slices/customField";
import { getIsRefresh } from "stores/slices/layout";
import { doGetWorkspacePage } from "stores/slices/workspace";
import { converInputFileToArray, formatBytes } from "utils";
import { YupValidations } from "utils/validation";
import * as Yup from "yup";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";
import ModalForm from "components/forms/components/modalForm";

import {
  DEFAULT_HEADERS_COLUMN,
  DEFAULT_HEADERS_COLUMNS,
} from "../../../constants/index";
import BroadcastListDetailTable from "../broadcastListDetailTable";
const BroadcastListForm = props => {
  const {
    onCancel,
    isCreate,
    isUpload,
    setIsUpload,
    broadcastListSelected,
    workspaceId,
    workspaceName,
    setIsRefresh,
    setIsData,
    isViewPage,
    isImport,
    isDefault,
    isUpdate,
    setIsOpenModalProgressing,
    userType,
  } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [broadcastListDetail, setBroadcastListDetail] = useState({});
  const [columns, setColumns] = useState([]);
  const [maxCol, setMaxCol] = useState(0);
  const [listCustomers, setListCustomers] = useState([]);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [workspacecQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
    sortFieldWorkspace: "createdTime",
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const customFields = useSelector(getAllCustomField);
  const isRefresh = useSelector(getIsRefresh);

  useEffect(() => {
    if (userType === USER_TYPE.SUPER_ADMIN) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  }, [userType]);

  useEffect(() => {
    let defaultCol = [
      ...DEFAULT_HEADERS_COLUMNS.map(header => {
        return {
          title: header.title,
          width: 220,
          dataIndex: header.dataIndex,
          key: header.dataIndex,
          isChangeHeader: true,
          ellipsis: {
            showTitle: false,
          },
        };
      }),
    ];
    if (customFields && customFields.length > 0) {
      defaultCol = [
        ...defaultCol,
        ...customFields.map(field => {
          return {
            title: field.name,
            width: 220,
            dataIndex: field.id,
            key: field.id,
            isChangeHeader: true,
            ellipsis: {
              showTitle: false,
            },
          };
        }),
      ];
    }
    if (defaultCol.length > maxCol) {
      if (maxCol >= 1 && maxCol <= 3) {
        let isPhoneNumber = false;
        let isEmail = false;
        let colData = null;
        listCustomers.map(customer => {
          if (customer.email) {
            isEmail = true;
          }
          if (customer.phoneNumber) {
            isPhoneNumber = true;
          }
          DEFAULT_HEADERS_COLUMN.filter(
            col => col !== "phoneNumber" && col !== "email"
          ).map(key => {
            if (
              customer[key] !== "" &&
              customer[key] !== null &&
              customer[key] !== undefined
            ) {
              customer["firstName"] = customer[key];
              customer[key] = null;
              colData = "firstName";
              return;
            }
          });
        });
        switch (maxCol) {
          case 1:
            defaultCol.map((col, index) => {
              if (colData) {
                if (col.dataIndex === colData) {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[0];
                  defaultCol[0] = changeCol;
                }
              }
              if (isPhoneNumber) {
                if (col.dataIndex === "phoneNumber") {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[0];
                  defaultCol[0] = changeCol;
                }
              }
              if (isEmail) {
                if (col.dataIndex === "email") {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[0];
                  defaultCol[0] = changeCol;
                }
              }
              return col;
            });
            break;
          case 2:
            defaultCol.map((col, index) => {
              if (isPhoneNumber) {
                if (col.dataIndex === "phoneNumber") {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[0];
                  defaultCol[0] = changeCol;
                }
              }
              if (isEmail) {
                if (col.dataIndex === "email") {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[1];
                  defaultCol[1] = changeCol;
                }
              }
              if (colData) {
                if (col.dataIndex === colData) {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[0];
                  defaultCol[0] = changeCol;
                }
              }
              return col;
            });
            break;
          case 3:
            defaultCol.map((col, index) => {
              if (colData) {
                if (col.dataIndex === colData) {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[0];
                  defaultCol[0] = changeCol;
                }
              }
              if (isPhoneNumber) {
                if (col.dataIndex === "phoneNumber") {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[1];
                  defaultCol[1] = changeCol;
                }
              }
              if (isEmail) {
                if (col.dataIndex === "email") {
                  const changeCol = defaultCol[index];
                  defaultCol[index] = defaultCol[2];
                  defaultCol[2] = changeCol;
                }
              }
              return col;
            });
            break;
        }
        defaultCol.splice(maxCol, defaultCol.length - maxCol);
      } else {
        if (broadcastListDetail.list && broadcastListDetail.list.length > 0) {
          const currentCol = Object.keys(broadcastListDetail.list[0]);
          const newHeader = [
            ...currentCol.map(col => {
              return {
                title: renderHeader(col),
                width: 220,
                dataIndex: col,
                key: col,
                isChangeHeader: true,
                ellipsis: {
                  showTitle: false,
                },
              };
            }),
          ];
          defaultCol = [...newHeader];
        }

        defaultCol.splice(maxCol, defaultCol.length - maxCol);
      }
    }
    if (defaultCol.length < maxCol) {
      // add ignore col
      for (let i = defaultCol.length; i < maxCol; i++) {
        defaultCol.push({
          title: `Ignore`,
          width: 220,
          dataIndex: `ignore${i}`,
          key: `ignore`,
          isChangeHeader: true,
          ellipsis: {
            showTitle: false,
          },
        });
      }
    }
    setColumns(defaultCol);
  }, [maxCol]);
  useEffect(() => {
    if (broadcastListSelected) {
      setIsUpload(true);
      setBroadcastListDetail({
        ...broadcastListSelected,
      });
    }
  }, [broadcastListSelected]);

  useEffect(() => {
    if (
      customFields &&
      broadcastListDetail.list &&
      broadcastListDetail.list.length > 0
    ) {
      const defaultCol = [
        ...DEFAULT_HEADERS_COLUMNS.map(header => {
          return {
            title: header.title,
            width: 220,
            dataIndex: header.dataIndex,
            key: header.dataIndex,
            isChangeHeader: true,
            ellipsis: {
              showTitle: false,
            },
          };
        }),
        ...customFields.map(field => {
          return {
            title: field.name,
            width: 220,
            dataIndex: field.id,
            key: field.id,
            isChangeHeader: true,
            ellipsis: {
              showTitle: false,
            },
          };
        }),
      ];
      if (defaultCol.length > maxCol) {
        defaultCol.splice(maxCol, defaultCol.length - maxCol);
      }
      if (defaultCol.length < maxCol) {
        // add ignore col
        for (let i = defaultCol.length; i < maxCol; i++) {
          defaultCol.push({
            title: `Ignore`,
            width: 220,
            dataIndex: `ignore${i}`,
            key: `ignore`,
            isChangeHeader: true,
            ellipsis: {
              showTitle: false,
            },
          });
        }
      }
      setColumns(defaultCol);
    }
  }, [customFields]);

  const renderHeader = head => {
    let newHead = "";
    if (head.includes("ignore")) {
      newHead = "Ignore";
    } else {
      switch (head) {
        case "firstName":
          newHead = "First Name";
          break;
        case "lastName":
          newHead = "Last Name";
          break;
        case "phoneNumber":
          newHead = "Mobile Phone";
          break;
        case "email":
          newHead = "Email";
          break;
        case "profileImage":
          newHead = "Image";
          break;
        case "facebook":
          newHead = "Facebook";
          break;
        case "instagram":
          newHead = "Instagram";
          break;
        case "twitter":
          newHead = "Twitter";
          break;
        case "snapchat":
          newHead = "Snapchat";
          break;
      }
    }
    return newHead;
  };

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      setListAllWorkspace(
        removeDuplicates([...listAllWorkspace, ...payload.content])
      );
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspacecQueries.pageNumber <= totalWorkspacePages &&
      !loadingList
    ) {
      fetchListWorkspace({
        ...workspacecQueries,
        pageNumber: workspacecQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const handleSearchKeyWorkspace = key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          id: item.id,
          name: `${item.name}`,
        };
      });
      setOptionWorkspace(newOptions);
    } else {
      setOptionWorkspace([]);
    }
  }, [listAllWorkspace]);

  const inputItems = [
    {
      type: "select-search",
      key: "workspaceId",
      label: "label.workspace",
      placeholder: "label.workspace",
      value: "",
      options: workspaceOption,
      selectKeyValue: "id",
      span: 24,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          fontSize: "14px",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        loading: loadingList,
        handleScroll: handleScrollWorkspace,
        handleSearchKey: handleSearchKeyWorkspace,
      },
      required: !isImport ? true : false,
    },
    {
      type: "text",
      key: "name",
      label: t("broadcastList.label.broadcastListName"),
      value: "",
      span: 24,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          fontSize: "14px",
        },
        styleLabel: {
          fontWeight: "bold",
        },
      },
      required: !isImport ? true : false,
      // disabled: openModal === "VIEW",
    },
    {
      type: "textarea",
      key: "description",
      label: t("broadcastList.label.description"),
      placeholder: "",
      value: "",
      span: 24,
      style: {
        paddingBottom: 4,
        width: "100%",
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        maxLength: 5000,
      },
      // disabled: openModal === "VIEW",
    },
    {
      type: "file-dragger",
      key: "file",
      label: t("broadcastList.label.file"),
      config: {
        uploadText: t("broadcastList.label.uploadText"),
        uploadHint: t("broadcastList.label.uploadHint"),
        description: t("broadcastList.text.description"),
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        accept: ".csv, .txt, .tsv",
      },
    },
  ];
  const onSubmitForm = async data => {
    if (data.file && data.file.name) {
      if (
        data.file.name.includes(".txt") ||
        data.file.name.includes(".csv") ||
        data.file.name.includes(".tsv")
      ) {
        const fileUrl = URL.createObjectURL(data.file);
        const response = await fetch(fileUrl);

        const text = await response.text();
        if (text.length === 0) {
          setIsData(false);
          setBroadcastListDetail({
            name: data.name,
            description: data.description,
            fileSize: "",
            fileContain: "",
            fileName: "",
            list: [],
          });
          setIsUpload(true);
        } else {
          setIsData(true);
          const customFieldHeaders =
            customFields.length > 0
              ? customFields.map(field => {
                  return field.id;
                })
              : [];
          Papa.parse(data.file, {
            header: false,
            complete: result => {
              const newData = converInputFileToArray(
                result.data,
                [...DEFAULT_HEADERS_COLUMN, ...customFieldHeaders],
                setMaxCol
              );
              if (newData.length > 0) {
                newData.map((item, index) => {
                  let isXSS = false;
                  if (index > 0) {
                    Object.keys(item).map(key => {
                      if (
                        item[key] !== "" &&
                        item[key] !== undefined &&
                        !PATTERNS.XSS_PATTERN.test(item[key])
                      ) {
                        isXSS = true;
                      }
                    });
                  }
                  if (isXSS) {
                    newData.splice(index, 1);
                  }
                });
                newData.map((item, index) => {
                  if (index > 0) {
                    if (!PATTERNS.PHONE_NUMBER.test(item.phoneNumber)) {
                      newData.splice(index, 1);
                    }
                  }
                });
                newData.map((item, index) => {
                  if (index > 0) {
                    if (item.email && !item.email.includes("@")) {
                      newData.splice(index, 1);
                    }
                  }
                });
              }
              setListCustomers(newData);
              setBroadcastListDetail({
                name: data.name,
                description: data.description,
                fileSize: formatBytes(data.file.size),
                fileContain: `${newData.length} ${
                  newData.length === 1 ? "recipient" : "recipients"
                }`,
                fileName: data.file.name,
                list: newData,
                workspaceId: values.workspaceId,
              });
              setIsUpload(true);
            },
          });
          // const _data = await covertFileToArray(
          //   data,
          //   data.file.name.includes(".tsv") ? "," : ",",
          //   [...DEFAULT_HEADERS_COLUMN, ...customFieldHeaders],
          //   setMaxCol
          // );
          // if (_data.length > 0) {
          //   _data.map((item, index) => {
          //     let isXSS = false;
          //     if (index > 0) {
          //       Object.keys(item).map(key => {
          //         if (
          //           item[key] !== "" &&
          //           item[key] !== undefined &&
          //           !PATTERNS.XSS_PATTERN.test(item[key])
          //         ) {
          //           isXSS = true;
          //         }
          //       });
          //     }
          //     if (isXSS) {
          //       _data.splice(index, 1);
          //     }
          //   });
          //   _data.map((item, index) => {
          //     if (index > 0) {
          //       if (!PATTERNS.PHONE_NUMBER.test(item.phoneNumber)) {
          //         _data.splice(index, 1);
          //       }
          //     }
          //   });
          //   _data.map((item, index) => {
          //     if (index > 0) {
          //       if (item.email && !item.email.includes("@")) {
          //         _data.splice(index, 1);
          //       }
          //     }
          //   });
          // }
          // setListCustomers(_data);
          // setBroadcastListDetail({
          //   name: data.name,
          //   description: data.description,
          //   fileSize: formatBytes(data.file.size),
          //   fileContain: `${_data.length} ${
          //     _data.length === 1 ? "recipient" : "recipients"
          //   }`,
          //   fileName: data.file.name,
          //   list: _data,
          //   workspaceId: values.workspaceId,
          // });
          // setIsUpload(true);
        }
      } else {
        setIsData(false);
        toast.error("Must be upload file with type csv, tsv or txt");
      }
    } else {
      setIsData(false);
      setBroadcastListDetail({
        name: data.name,
        description: data.description,
        fileSize: "",
        fileContain: "",
        fileName: "",
        list: [],
      });
      setIsUpload(false);
      setIsOpenConfirm(true);
    }
  };

  const validationSchema = Yup.object().shape({
    workspaceId:
      userType === USER_TYPE.SUPER_ADMIN && !isImport
        ? Yup.string().required("validate.required")
        : Yup.string().nullable(),
    name: isImport ? Yup.string().nullable() : YupValidations.requiredString,
    file: isViewPage
      ? Yup.string().required("validate.required")
      : Yup.string().nullable(),
    description: Yup.string()
      .matches(PATTERNS.XSS_PATTERN, "validate.noxss")
      .max(5000, "validate.max_length_5000")
      .nullable(),
  });

  const BroadcastListForm = useFormik({
    initialValues: {
      name: "",
      description: "",
      file: "",
      workspaceId: "",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmitForm,
  });
  const { values, setFieldValue, handleSubmit, setValues, handleReset } =
    BroadcastListForm;

  const handleCreateBroadcast = async () => {
    setLoading(true);
    await dispatch(
      doCreateBroadcastList({
        data: {
          workspaceId: workspaceId || values.workspaceId,
          name: values.name,
          description: values.description,
          queries: {
            workspaceId: workspaceId || values.workspaceId,
            page: 1,
            size: 10,
          },
        },
      })
    );
    setLoading(false);
    setIsOpenConfirm(false);
    onCancel();
    handleReset();
    setValues();
    dispatch(setIsRefresh(uuid()));
  };
  const handleTitleConfirm = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
      <span style={{ marginLeft: 10, fontSize: 16 }}>
        {t("broadcastList.title.confirmAddBroadcastList")}
      </span>
    </div>
  );

  return (
    <div>
      {!isUpload && (
        <>
          <FormInput
            items={inputItems
              .map(item => {
                if (isImport) {
                  if (item.key === "file") {
                    item.label = t(item.label);
                    item.value = getIn(values, item.key);
                    return { ...item };
                  }
                } else {
                  if (userType === USER_TYPE.USER) {
                    if (item.key !== "workspaceId") {
                      item.label = t(item.label);
                      item.value = getIn(values, item.key);
                      return { ...item };
                    }
                  } else {
                    if (item.key) {
                      item.label = t(item.label);
                      item.value = getIn(values, item.key);
                      return { ...item };
                    }
                  }
                }
              })
              .filter(item => item !== undefined && item)}
            form={BroadcastListForm}
            onChange={setFieldValue}
            layout={"vertical"}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "20px",
            }}
          >
            <AppButton
              label={t("label.cancel")}
              color={"grey"}
              // loading={loading}
              type="button"
              onClick={() => {
                onCancel();
                handleReset();
                setValues();
              }}
              size={"medium"}
              className={"cancelButton"}
            />
            <AppButton
              label={isCreate ? t("button.create") : t("button.import")}
              color={"blue"}
              // loading={loading}
              type="submit"
              onClick={handleSubmit}
              size={"medium"}
            />
          </div>
        </>
      )}
      {isUpload && (
        <>
          <BroadcastListDetailTable
            broadcastListDetail={broadcastListDetail}
            setBroadcastListDetail={setBroadcastListDetail}
            onCancel={onCancel}
            isCreate={isCreate}
            workspaceId={workspaceId}
            workspaceName={workspaceName}
            isRefresh={isRefresh}
            setIsData={setIsData}
            columns={columns}
            defaultColumns={DEFAULT_HEADERS_COLUMNS}
            customFields={customFields}
            isViewPage={isViewPage}
            isImport={isImport}
            isDefault={isDefault}
            isUpdate={isUpdate}
            setIsOpenModalProgressing={setIsOpenModalProgressing}
          />
        </>
      )}
      <ModalForm
        isOpen={isOpenConfirm}
        title={handleTitleConfirm()}
        onCancel={() => setIsOpenConfirm(false)}
        maskClosable={false}
        footer={[
          <AppButton
            key="button"
            label={t("label.cancel")}
            color={"grey"}
            loading={loading}
            type="button"
            onClick={() => {
              setIsOpenConfirm(false);
            }}
            size={"medium"}
          />,
          <AppButton
            key="button"
            label={t("button.create")}
            color={"blue"}
            loading={loading}
            type="submit"
            onClick={() => {
              handleCreateBroadcast();
            }}
            size={"medium"}
          />,
        ]}
      >
        <div style={{ height: 50, marginLeft: 35, fontSize: 14 }}>
          {t("broadcastList.text.confirmAddBroadcastList")}
        </div>
      </ModalForm>
    </div>
  );
};

export default BroadcastListForm;
